// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '유영제약',
  targetSheetName: '260101_유영_CSM',
  headerRowIndex: 3,
  headerRowCount: 3,
  dataStartRowIndex: 6,
  columnMapping: {
    drugName: '제품명',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
  requiredHeaders: ['No.', '제품명', '성분명', '수수료', '비고'],
});
